// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-collection-dropdown-action {
  display: flex;
  align-items: center;
}
.dl-collection-dropdown-action__text {
  margin-left: 8px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/DropdownAction/DropdownAction.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;AACJ;AACI;EACI,gBAAA;AACR","sourcesContent":[".dl-collection-dropdown-action {\n  display: flex;\n  align-items: center;\n}\n.dl-collection-dropdown-action__text {\n  margin-left: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
